import React, { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";

const MORNING = [
  "Morning, {n}. What did the team learn yesterday?",
  "Morning, {n}. Kettle on, notes open.",
  "Early start, {n}? Let's get it written down.",
  "Morning, {n}. What's worth keeping from today?",
];
const AFTERNOON = [
  "Afternoon, {n}. Anything from site worth saving?",
  "Afternoon, {n}. Catch it before it's forgotten.",
  "Afternoon, {n}. What do you know that the team doesn't yet?",
  "Back at it, {n}.",
];
const EVENING = [
  "Evening, {n}. Log it before you clock off.",
  "Evening, {n}. One note now saves a phone call later.",
  "Late one, {n}? Keep it brief.",
  "Evening, {n}. Get it out of your head and into here.",
];
const ANY_TIME = [
  "Welcome back, {n}.",
  "What have you picked up today, {n}?",
  "Good to see you, {n}. What's new on the job?",
  "{n}, what's the one thing the next person should know?",
  "Right then, {n}. Where were we?",
  "Knowledge walks out the gate every day. Not today, {n}.",
];
const MONDAY = ["New week, {n}. Fresh notes."];
const FRIDAY = ["Friday, {n}. Capture it before the weekend wipes it."];

function candidates() {
  const now = new Date();
  const h = now.getHours();
  const day = now.getDay();
  const timePool = h < 12 ? MORNING : h < 17 ? AFTERNOON : EVENING;
  let pool = [...timePool, ...ANY_TIME];
  if (day === 1) pool = [...MONDAY, ...MONDAY, ...pool];
  if (day === 5) pool = [...FRIDAY, ...FRIDAY, ...pool];
  return pool;
}

export const Greeting = ({ className = "" }) => {
  const { user } = useAuth();
  const msg = useMemo(() => {
    const first = (user?.name || "there").split(" ")[0];
    const p = candidates();
    return p[Math.floor(Math.random() * p.length)].replace("{n}", first);
  }, [user?.name]);

  if (!user) return null;
  return (
    <div
      className={`font-display font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-sky-300 via-sky-400 to-sky-300 drop-shadow-[0_2px_12px_rgba(40,153,255,0.35)] ${className}`}
      data-testid="home-greeting"
    >
      {msg}
    </div>
  );
};
